import { c as _c } from "react/compiler-runtime";
import React from "react";
import CustomTooltip from "./CustomTooltip";
import WaveProfileTooltip from "@/components/waves/utils/profile/WaveProfileTooltip";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
interface WaveProfileTooltipWrapperProps {
  readonly waveId: string;
  readonly initialWave?: ApiWaveMin | null;
  readonly fallbackName?: string | undefined;
  readonly children: React.ReactElement;
  readonly placement?: "top" | "bottom" | "left" | "right" | "auto" | undefined;
}
export default function WaveProfileTooltipWrapper(t0) {
  const $ = _c(10);
  const {
    waveId,
    initialWave: t1,
    fallbackName,
    children,
    placement: t2
  } = t0;
  const initialWave = t1 === undefined ? null : t1;
  const placement = t2 === undefined ? "auto" : t2;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  if (hasTouchScreen) {
    let t3;
    if ($[0] !== children) {
      t3 = <>{children}</>;
      $[0] = children;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  let t3;
  if ($[2] !== fallbackName || $[3] !== initialWave || $[4] !== waveId) {
    t3 = <WaveProfileTooltip waveId={waveId} initialWave={initialWave} fallbackName={fallbackName} />;
    $[2] = fallbackName;
    $[3] = initialWave;
    $[4] = waveId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== placement || $[8] !== t3) {
    t4 = <CustomTooltip content={t3} placement={placement} delayShow={500} delayHide={0}>{children}</CustomTooltip>;
    $[6] = children;
    $[7] = placement;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}